import { gql } from '@apollo/client';
import { ERRORS_FRAGMENT } from '@/graphql/fragments';

export const CHARTER_RECONFIRMATION_INFO_QUERY = gql`
    ${ERRORS_FRAGMENT}
    query CharterReconfirmationInfo($token: String!) {
        charterReconfirmationInfo(token: $token) {
            status
            errors {
                ...ErrorType
            }
            token
            itineraryNumber
            canReconfirm
            reconfirmationStatus
            reconfirmationStatusDisplay
            flight {
                number
                departingCity {
                    name
                    code
                }
                arrivingCity {
                    name
                    code
                }
                departingDatetime
                arrivingDatetime
                carrier {
                    name
                }
            }
            passengers {
                id
                fullName
                passport
                status
                statusDisplay
            }
        }
    }
`;
